import { getCookie, isUUID, setCookie, setUUID } from '@common/helpers/cookie';
import { useQuery } from '@react/services/api';
import {
  REFERRER,
  SESSION,
  UTM_COOKIE,
  UTM_UPDATED,
} from '@sly/core/constants/cookie';
import { setClientData } from '@sly/core/constants/localStorage';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

const UserCookiesContainer = ({ children }) => {
  const { query: qs } = useRouter();
  const getUUIDAux = useQuery('getUuidAux');

  const setUUIDCookie = useCallback(() => {
    if (isUUID(qs.sly_uuid) && !getCookie(SESSION)) {
      setUUID(qs.sly_uuid);
    }
  }, [qs]);

  const updateUtmCookie = useCallback(
    (utmParams) => {
      // set cookie with new utm. If utm cookie present append to it
      const utmCookie = getCookie(UTM_COOKIE) || {};
      const clicks = utmCookie.clicks || [];
      clicks.push(utmParams);
      utmCookie.clicks = clicks;
      setCookie(UTM_COOKIE, JSON.stringify(utmCookie));
      // used by api middleware to check and update uuid_aux of user
      setCookie(UTM_UPDATED, true);
      getUUIDAux({ id: 'me' });
    },
    [getUUIDAux]
  );

  const storeClientData = useCallback(async () => {
    // Check if we have encrypted Homethrive data
    if (qs.data) {
      try {
        // Make API call to decrypt and transform the data
        const response = await fetch(`/api/homethrive?data=${qs.data}`, {
          method: 'GET',
        });

        const data = await response.json();

        if (data) {
          setClientData(data);

          if (data.affiliateId) {
            const utmParams = {
              campaign: data.affiliateId,
              source: 'affiliate',
              medium: 'affiliate',
              content: 'affiliate',
              term: 'affiliate',
              timestamp: new Date().toISOString(),
              fbclid: 'NA',
              gclid: qs.gclid || 'NA',
              affiliateid: data.affiliateId,
            };
            updateUtmCookie(utmParams);
          }
        }
      } catch (error) {
        console.error('Failed to process Homethrive data:', error);
      }
      return;
    }
  }, [qs]);

  const setUTMParamsCookie = useCallback(() => {
    if (qs.utm_campaign) {
      const utmParams = {
        campaign: qs.utm_campaign,
        source: qs.utm_source || 'NA',
        medium: qs.utm_medium || 'NA',
        content: qs.utm_content || 'NA',
        term: qs.utm_term || 'NA',
        timestamp: new Date().toISOString(),
        fbclid: qs.fbclid || 'NA',
        gclid: qs.gclid || 'NA',
      };

      updateUtmCookie(utmParams);
    }
  }, [
    getUUIDAux,
    qs.utm_campaign,
    qs.utm_content,
    qs.utm_medium,
    qs.utm_source,
    qs.utm_term,
    qs.fbclid,
    qs.gclid,
    1,
  ]);

  const setReferrer = () => {
    const { referrer } = document;
    setCookie(REFERRER, referrer);
    return referrer;
  };

  const setIfEmptyReferrer = () => {
    return getCookie(REFERRER) || setReferrer();
  };

  useEffect(() => {
    setUUIDCookie();
    setUTMParamsCookie();
    setIfEmptyReferrer();
    storeClientData();
  });

  return children;
};

export default UserCookiesContainer;
